import React from 'react';
import FormGroupCreate from '../../../components/common/Forms/FormGroupCreate';
import { ProtectedRoute, PageGuard } from '../../../components/common/security/ProtectedRoute';

const QaqcFormGroupCreate: React.FC = () => {
  return (
    <ProtectedRoute>
      <PageGuard>
        <div style={{ padding: 24 }}>
          <FormGroupCreate />
        </div>
      </PageGuard>
    </ProtectedRoute>
  );
};

export default QaqcFormGroupCreate;
